import React from "react";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import Oops from "../../assets/assets/oops.svg";
import Sorry from "../../assets/assets/sorry.svg";

const NotFound = () => {
    return (
        <div className="wrapper-change">
            <div className="verification-logo">
                <img src={Nibss} alt="logo" />
            </div>
            <div className="not-found">
                <div className="not-found-container">
                    <div className="not-found-container-image">
                        <img src={Oops} alt="not-found-icon" />
                    </div>

                    <div className="not-found-container-image2">
                        <img src={Sorry} alt="page-not-found" />
                    </div>
                    <div className="not-found-container-text">Go to <a href="/">home</a></div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;